<template>
    <section class="general-modal">
        <h1 class="modal-title"> Veelgestelde vragen </h1>
        <h2>Onze tevredenheidsgarantie</h2>
        <p>Het heeft geen zin om tegen je zin lid te blijven van Testaankoop. Dankzij onze tevredenheidsgarantie ben je vrij om je abonnement stop te zetten wanneer je dat wenst. Je verwittigt ons
            ten laatste 15 werkdagen voor het einde van elke maandelijkse vervaldag*. Er is dus geen enkele aankoopverplichting en je bent ons geen verklaring verschuldigd. <br>
            *Opgelet: elke begonnen maand wordt beschouwd als een volledige maand.
        </p>

        <h2>Wat gebeurt er na mijn proefperiode?</h2>
        <p>Als je wilt blijven profiteren van alle voordelen en diensten van Testaankoop na je proefperiode, hoef je niets te doen. Na je proefperiode waar je € 2 betaalt voor 2 maanden, geniet je van een exclusieve korting van 50 % tot het einde van het eerste abonnementsjaar en betaalt slechts € 12,33 per maand in plaats van € 24,66. Dat is weinig, in vergelijking met de honderden euro's die je dankzij Testaankoop bespaart.</p>

        <h2>Hoe kan ik mijn abonnement beëindigen?</h2>
        <p>Je kan je abonnement stopzetten via e mail, brief of telefoon, 15 werkdagen voor het einde van elke maandelijkse vervaldag.</p>

        <h2>Is deze site beveiligd?</h2>
        <p>Jouw veiligheid is onze eerste prioriteit. Op de website van Testaankoop garanderen we dat elke betaling veilig gebeurt. Wij maken gebruik van een vooraanstaande technologie: een beveiligingsserver (SSL) die instaat voor de betrouwbaarheid van al onze online activiteiten. Deze software zet al je persoonlijke gegevens die wij nodig hebben voor de behandeling van je bestellingen (naam, adres, bankgegevens) om in codes op het moment dat je ze invoert. Met dit systeem kunnen anderen onmogelijk je gegevens lezen op het moment dat ze over het internet naar onze site worden doorgestuurd.</p>

        <h2>Hoe kan ik Testaankoop contacteren?</h2>
        <p>Je kunt je brief richten aan Testaankoop, Hollandstraat 13, 1060 Brussel. Of via e mail op <a href="https://www.testaankoop.be/contact" target="_blank">www.testaankoop.be/contact</a>. Of telefonisch via onze klantendienst op 02/892 37 00.</p>

        <h2>Kan ik de magazines digitaal consulteren op mijn smartphone?</h2>
        <p>Ja, onze magazines Testaankoop en Testaankoop Gezond zijn digitaal beschikbaar op <a href="https://testaankoop.be/applicaties" target="_blank">testaankoop.be/applicaties</a>.</p>
    </section>
</template>

<script>
export default {
    name: "FaqModal"
}
</script>

<style scoped>

</style>
